import type { ReactNode } from 'react';
import { cn } from '@rocco/utils/cn';

interface StepContentProps {
    /** Content to render inside the scrollable container */
    children: ReactNode;
    /** Additional CSS classes */
    className?: string;
    /** Use smaller gap on desktop (e.g. guest invitation step) */
    variant?: 'default' | 'guest';
}

/**
 * Scrollable content container for HDE registration form steps.
 * Provides consistent styling with hidden scrollbar and flex layout.
 * Dark mode: white text for #27282A background.
 */
export function StepContent({ children, className }: StepContentProps) {
    return (
        <div
            className={cn(
                'flex min-h-0 flex-1 flex-col gap-4',

                className,
            )}
        >
            {children}
        </div>
    );
}
